import { makeAutoObservable, runInAction } from 'mobx';
import LoadingService from 'src/utils/LoadingService';
import { PaymentType, PATH } from 'src/constants';
import policyStore from 'src/stores/PolicyStore';

export class PaymentStore {
    periodicPaymentInfo: any;
    topUpPaymentInfo: any;
    otherPaymentInfo: any;

    constructor() {
        makeAutoObservable(this);
    }

    initPeriodicPaymentInfo(periodicPolicy: any) {
        let amount = 0;
        if(periodicPolicy?.duePremium?.length > 0){
            amount = Number(periodicPolicy.duePremium[0].dueAmount) - Number(periodicPolicy.suspenseAmt);
            if(amount < 0){
                amount = 0;
            }
        }
        runInAction(() => {
            this.updatePeriodicPaymentInfo({
                ...periodicPolicy,
                amount: amount
            });
        });
    }

    initTopUpPaymentInfo(topUpPolicy: any) {
        let min = Number(topUpPolicy?.topUpMinAmt);
        let max = Number(topUpPolicy?.topUpMaxAmt);
        runInAction(() => {
            this.updateTopUpPaymentInfo({
                ...topUpPolicy,
                amount: 0,
                topUpValue: '',
                errTopUpValue: '',
                topUpValueInput: '',
                topUpValueFormat: '',
                disabledInput: min > max
            });
        });
        this.otherPaymentInfo = {
            feeTypes: [
                {
                    id: 1,
                    name: 'pay_fee_addition_1',
                    checked: false
                }
            ]
        }
    }

    updatePeriodicPaymentInfo(data: any) {
        if (!this.periodicPaymentInfo) {
          this.periodicPaymentInfo = data;
        } else {
          this.periodicPaymentInfo = {
            ...this.periodicPaymentInfo,
            ...data,
          };
        }
    }

    updateTopUpPaymentInfo(data: any) {
        if (!this.topUpPaymentInfo) {
          this.topUpPaymentInfo = data;
        } else {
          this.topUpPaymentInfo = {
            ...this.topUpPaymentInfo,
            ...data,
          };
        }
    }

    async getPolicyPayment({ policyNum, bgIndex , history, showDetail = false }) {
        try {
            LoadingService.instance.current.open();
            let periodicPolicy = await policyStore.getPeriodicPolicy({ policyNum, bgIndex, showDetail });
            this.initPeriodicPaymentInfo(periodicPolicy);
            runInAction(() => {
                this.topUpPaymentInfo = {};
            });
            LoadingService.instance.current.close();
            history.push(PATH.PAYMENT);
        } catch (error) {
            LoadingService.instance.current.close();
        }
    }

    async getPeriodicPolicyPayment({ policyNum, bgIndex, history, showDetail = false }) {
        try {
            LoadingService.instance.current.open();
            let periodicPolicy = await policyStore.getPeriodicPolicy({ policyNum,
                bgIndex, showDetail });
            this.initPeriodicPaymentInfo(periodicPolicy);
            LoadingService.instance.current.close();
            history.push(PATH.PERIODIC_PAYMENT);
        } catch (error) {
            LoadingService.instance.current.close();
        }
    }

    async getPeriodicPolicyPaymentNew({ policyNum, bgIndex, history, showDetail = false, birthDate }) {
        try {
            LoadingService.instance.current.open();
            let periodicPolicy = await policyStore.getPeriodicPolicyNew({ policyNum,
                bgIndex, showDetail, birthDate });
            this.initPeriodicPaymentInfo(periodicPolicy);
            LoadingService.instance.current.close();
            history.push(PATH.PERIODIC_PAYMENT);
        } catch (error) {
            LoadingService.instance.current.close();
        }
    }

    async getTopUpPolicyPayment({ policyNum, bgIndex, history, showDetail = false }) {
        try {
            LoadingService.instance.current.open();
            let topUpPolicy = await policyStore.getTopUpPolicy({
                policyNum,
                paymentType: PaymentType.TOPUP_PAYMENT,
                bgIndex,
                showDetail
            });
            this.initTopUpPaymentInfo(topUpPolicy);
            LoadingService.instance.current.close();
            if(history){
                history.push(PATH.TOPUP_PAYMENT);
            }
            return true;
        } catch (error) {
            LoadingService.instance.current.close();
            throw error;
        }
    }

    async getTopUpPolicyPaymentNew({ policyNum, bgIndex, history, showDetail = false, birthDate }) {
        try {
            LoadingService.instance.current.open();
            let topUpPolicy = await policyStore.getTopUpPolicyNew({
                policyNum,
                paymentType: PaymentType.TOPUP_PAYMENT,
                bgIndex,
                showDetail,
                birthDate
            });
            this.initTopUpPaymentInfo(topUpPolicy);
            LoadingService.instance.current.close();
            if(history){
                history.push(PATH.TOPUP_PAYMENT);
            }
            return true;
        } catch (error) {
            LoadingService.instance.current.close();
            throw error;
        }
    }

}

export default new PaymentStore();
